module.exports = __webpack_public_path__ + "static/media/b1_p7_clickable_b.29840747.png";